module.exports = "/_next/static/images/img__fire_right-03aa7044bdb50a0e9802d9d2d63448f7.png";